import React, { useContext, useEffect } from 'react';
import api, { cooperplaceApi } from 'services/api';

import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaExternalLinkAlt } from 'react-icons/fa';

import Text from 'v3/components/Text';
import Select from 'v3/components/Select';

import { useTravel } from 'v3/pages/Travel';
import { useCurrentUser } from 'hooks';
import { useSnackbar } from 'v3/components/Snackbar';
import { BlockedTravelContext } from 'contexts/BlockedTravelProvider';

import { checkIfBlacklisted } from '../controller'

export const clientLoadFieldsToSum = [
  'ad_valorem',
  'charge_value',
  'discharge_value',
  'ferry',
  'gris',
  'ICMS',
  'taker_value',
  'toll_value',
];

export const inputsLoadConditionsToShow = [
  'not_selected',
  'customer_retains',
  'not_selected_discharge',
  'client_pays_insurance',
  'receives_client_and_transfers',
  'only_with_receipt',
  'receives_client_and_retains',
  'transfers_to_carrier',
  'not_selected_icms',
  'retains_in_transporter',
];

function ShippingCompany({
  errors,
  editing,
  shippingCompany,
  setShippingCompany,
  onChangeShippingCompany,
}) {
  const linkTextStyle = {
    textDecoration: 'underline',
    display: 'flex',
    alignItems: 'center',
    gap: '0.4rem',
    width: 'fit-content',
  };
  const travel = useTravel();
  const snackbar = useSnackbar();
  const user = useCurrentUser();

  const { setIsFetchingBenner } = useContext(BlockedTravelContext);

  const updateShippingCompanyFromBenner = async (cnpj) => {
    if (!cnpj) return;
    try {
      const url = `shipping-company/importFromBenner?cpfCnpj=${cnpj}`;
      const { data } = await cooperplaceApi.get(url);
      snackbar.show(<Text>{data?.message}</Text>, {
        type: 'success',
      });
    } catch (error) {
      snackbar.show(<Text>Transportadora não encontrada no Benner!</Text>, {
        type: 'error',
      });
    }
  };

  async function handleChangeShippingCompany(value) {

    const onBlacklistedCallback = blacklist =>
      snackbar.show(
        <Col style={{ display: 'flex', flexDirection: 'column', gap: '0.5' }}>
          <Text>
            Não foi possível selecionar a transportadora pois ela está bloqueada no blacklist
          </Text>
          {
            blacklist?.logs.length > 0 && (
              <Text>
                Descrição: {blacklist?.logs[0]?.description}
              </Text>
            )
          }
        </Col>,
        {
          type: 'error',
        }
      );
    const isBlackListed = await checkIfBlacklisted(
      value?.id,
      onBlacklistedCallback,
    );
    if (isBlackListed) return;

    await updateShippingCompanyFromBenner(value?.cgccpf);
    await onChangeShippingCompany(value);
    setIsFetchingBenner(false);
  }

  async function fetchShippingCompanies({ search, companyId }) {
    try {
      const response = await api.get(`persons/shipping-company`, {
        params: { search, company_id: companyId },
      });

      return response.data;
    } catch (ex) {
      return [];
    }
  }

  useEffect(() => {
    setShippingCompany(travel?.data?.shipper);
  }, [editing]);

  if (travel.isLoading) {
    return null;
  }

  return (
    <>
      {editing ? (
        <Row style={{ marginBottom: '1rem' }}>
          <Col xs={12} md={12}>
            <Text weight={500}>Transportadora</Text>
          </Col>
          <Col xs={12}>
            <Select.Async
              label="Razão Social *"
              value={shippingCompany}
              onSearch={(search) =>
                fetchShippingCompanies({
                  search,
                  companyId: user.company_id,
                })
              }
              getOptionLabel={(option) => {
                if (option.socialName && option.cpfCnpj) {
                  return `${option.socialName} - ${option.cpfCnpj}`;
                }
                return `${option.social_name} - ${option.cgccpf}`;
              }}
              getOptionValue={(option) => option.id}
              onChange={(item) => {
                handleChangeShippingCompany(item);
              }}
              error={errors}
            />
          </Col>
        </Row>
      ) : (
        <Row>
          <Text color="dark" type="header" weight={500}>
            Transportadora
          </Text>

          <Col xs={12}>
            <Text type="label" color="dark">
              Razão Social
            </Text>
            <Text>
              <Link
                target={travel.data.shipper?.id && '_blank'}
                to={travel.data.shipper?.id && `/transportadoras/${travel.data.shipper?.id}`}
              >
                <Text type="regular" color="light_blue" as="p" className="mt-2" style={linkTextStyle}>
                  {travel.data.shipper?.label || 'Não informado'}
                  <FaExternalLinkAlt color="#B5B5C3" size={12} />
                </Text>
              </Link>
            </Text>
          </Col>

          <Col xs={6}>
            <Text type="label" color="dark">
              Telefone
            </Text>

            <Text type="regular" color="gray" as="p" className="mt-2">
              {travel?.data?.shipper?.phone || 'Não informado'}
            </Text>
          </Col>
          <Col xs={6}>
            <Text type="label" color="dark">
              Nível de Serviço
            </Text>

            <Text type="regular" color="gray" as="p" className="mt-2">
              {travel?.data?.shipper?.shippingCompany?.descriptionServiceLevel || 'Não informado'}
            </Text>
          </Col>
          <Col xs={6}>
            <Text type="label" color="dark">
              Vinculo ao transportador
            </Text>

            <Text type="regular" color="gray" as="p" className="mt-2">
              {travel?.data?.shipperProps?.linkShippingCompany?.name || 'Não informado'}
            </Text>
          </Col>
        </Row>
      )}
    </>
  );
}

export default ShippingCompany;
